import { Radio, Space, Typography } from 'antd';
import { ClockCircleOutlined } from '@ant-design/icons';
import type { TimeRange } from '../../api/types';

const { Text } = Typography;

interface TimeRangeSelectorProps {
  value: TimeRange;
  onChange: (value: TimeRange) => void;
}

const TIME_RANGE_OPTIONS: { value: TimeRange; label: string }[] = [
  { value: '1h', label: '1 Hour' },
  { value: '6h', label: '6 Hours' },
  { value: '24h', label: '24 Hours' },
  { value: '7d', label: '7 Days' },
];

export function TimeRangeSelector({ value, onChange }: TimeRangeSelectorProps) {
  return (
    <Space>
      <ClockCircleOutlined />
      <Text>Time Range:</Text>
      <Radio.Group
        value={value}
        onChange={(e) => onChange(e.target.value)}
        optionType="button"
        buttonStyle="solid"
        options={TIME_RANGE_OPTIONS}
      />
    </Space>
  );
}
